var render = function render(_c,_vm){return _c('v-text-field',_vm._g(_vm._b({attrs:{"prepend-inner-icon":"mdi-music-accidental-sharp","outlined":"","label":"Model Number"}},'v-text-field',_vm.data.attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }